<h1 mat-dialog-title>Files to send with the summary</h1>

<div mat-dialog-content class="rsfp">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="rsfp__alert" *ngIf="loadError" data-test="load-error">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="!isLoading && !loadError">
        <p class="hint">
            Images and PDFs from the patient's timeline, as they look now. A PDF is sent with its pages.
            Choose up to {{ max }}.
        </p>

        <div class="rsfp__empty" *ngIf="!groups.length" data-test="no-files">
            <mat-icon>perm_media</mat-icon>
            <div>This patient's timeline has no images or PDFs to send.</div>
        </div>

        <!-- ONE grid across every entry (newest first, as the server lists them): a heading per entry left most entries a
             single tile wide. The entry each file came from is on the tile instead. -->
        <div class="rsfp__grid" *ngIf="groups.length">
            <ng-container *ngFor="let group of groups; trackBy: trackByKey">
                <button type="button" class="rsfp__tile" *ngFor="let file of group.files; trackBy: trackByRef"
                    [class.rsfp__tile--selected]="isSelected(file)" [disabled]="!isSelected(file) && atLimit"
                    [attr.aria-pressed]="isSelected(file)" (click)="toggle(file)" data-test="file-tile">
                    <img *ngIf="file.previewUrl" [src]="file.previewUrl" [alt]="file.fileName || 'Image'" class="rsfp__thumb" loading="lazy">
                    <mat-icon *ngIf="!file.previewUrl" class="rsfp__thumb rsfp__thumb--icon">{{ file.kind === 'pdf' ? 'picture_as_pdf' : 'image' }}</mat-icon>
                    <span class="rsfp__badge" *ngIf="isSelected(file)">{{ position(file) }}</span>
                    <span class="rsfp__pdf" *ngIf="file.kind === 'pdf'">PDF{{ file.pageCount ? ' · ' + file.pageCount + (file.pageCount === 1 ? ' page' : ' pages') : '' }}</span>
                    <span class="rsfp__name" [title]="file.fileName || ''">{{ file.fileName || (file.kind === 'pdf' ? 'Document' : 'Image') }}</span>
                    <span class="rsfp__entry" [title]="group.entryTitle">
                        <mat-icon>{{ group.sourceType === 'document' ? 'assignment_returned' : 'description' }}</mat-icon>
                        <span>{{ group.entryTitle }} · {{ group.entryDate | date: 'd MMM y' }}</span>
                    </span>
                </button>
            </ng-container>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end" class="rsfp__actions">
    <span class="hint rsfp__count">{{ selected.length }} of {{ max }} chosen</span>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="done()" [disabled]="isLoading || !!loadError" data-test="use-files">
        {{ selected.length ? 'Send ' + selected.length + (selected.length === 1 ? ' file' : ' files') : 'Send no files' }}
    </button>
</div>
